module.exports = __webpack_public_path__ + "img/global-not_schedule.png?8288fef5";